import { useLocation, useNavigate } from 'react-router-dom';

export const useNavigateWithCompanyFilter = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateWithCompanyFilter = (to: string) => {
    const params = new URLSearchParams(location.search);
    const nextParams = new URLSearchParams();

    if (params.has('filter')) {
      nextParams.set('filter', params.get('filter') ?? '');
    }

    navigate({
      pathname: to,
      search: nextParams.toString(),
    });
  };

  return navigateWithCompanyFilter;
};
